import React, { createContext, useContext, useState, useEffect } from "react";

const LanguageContext = createContext(null);
const STORAGE_KEY = "balticroots_lang";

export const LANGUAGES = [
  { code: "EN", label: "English" },
  { code: "DE", label: "Deutsch" },
  { code: "FR", label: "Français" },
  { code: "LV", label: "Latviešu" },
];

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState("EN");
  useEffect(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved) setLangState(saved);
  }, []);
  const setLang = (l) => {
    setLangState(l);
    localStorage.setItem(STORAGE_KEY, l);
  };
  return <LanguageContext.Provider value={{ lang, setLang }}>{children}</LanguageContext.Provider>;
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be inside LanguageProvider");
  return ctx;
};
